<div class="not-found--container">
  <div class="not-found--content">
    <p [innerHTML]="'notify.post.post_not_found' | translate"></p>
    <img src="assets/images/posts/404-post-not-found.svg" alt="Post Not Found SVG image" />
  </div>
</div>
